type Environments = {
  production: boolean;
  partnerKey?: string;
  apiDomain?: string;
  defaultDomain: string;
};

export const environment: Environments = {
  production: process.env.NODE_ENV === 'production',
  partnerKey: process.env.STORYBOOK_API_KEY,
  apiDomain: process.env.STORYBOOK_API_DOMAIN || 'https://api.level.travel',
  defaultDomain: 'level.travel',
} as const;
